import { render } from "./ManagerDashboardView.vue?vue&type=template&id=6f42e4a6"
import script from "./ManagerDashboardView.vue?vue&type=script&lang=js"
export * from "./ManagerDashboardView.vue?vue&type=script&lang=js"

import "./ManagerDashboardView.vue?vue&type=style&index=0&id=6f42e4a6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__